import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiantouzuo",
  "use": "icon-jiantouzuo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jiantouzuo\"><path fill=\"#8A8A9A\" d=\"M747.73 157.99L393.68 511.38l354.03 353a55.075 55.075 0 0 1 16.19 39c0 49.02-59.24 73.61-93.95 39L283.48 557.04c-14.16-9.97-23.42-26.42-23.42-45.06 0-15.23 6.18-29.01 16.17-38.98l393.7-392.97c34.71-34.64 93.97-10.06 93.97 38.98a55.152 55.152 0 0 1-16.17 38.98z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol